var _style, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0-arrow-down {\n\t\t\tfilter: url(#Adobe_OpacityMaskFilter-arrow-down);\n\t\t}\n\n\t\t.st1-arrow-down {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\n\t\t.st2-arrow-down {\n\t\t\tmask: url(#mask-2_1_-arrow-down);\n\t\t}\n\n\t\t.st3-arrow-down {\n\t\t\tfill: #00242D;\n\t\t}\n\t")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Arrow Down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Arrow-Down-arrow-down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-arrow-down"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter-arrow-down",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    id: "mask-2_1_-arrow-down"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_-arrow-down",
    className: "st1-arrow-down",
    d: "M7.7,9h8.7c0.6,0,0.9,0.7,0.5,1.1l-4.3,4.3c-0.3,0.3-0.7,0.3-1,0l-4.3-4.3 C6.8,9.7,7.1,9,7.7,9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mixin_x2F_Fill_x2F_Black-arrow-down",
    className: "st2-arrow-down"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-arrow-down",
    x: 0,
    y: 0,
    className: "st3-arrow-down",
    width: 24,
    height: 24
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.6e947bc6.svg";
export { ForwardRef as ReactComponent };